import { React, useState, useEffect } from 'react';
import axios from "axios";
import { BrowserRouter, Routes, Route, Navigate, Link } from 'react-router-dom';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import MenuMain from './private/components/MenuMain';
import FormRequest from './private/components/FormRequest';
import SingleTrack from './private/components/SingleTrack';
import UploadReceipt from './private/components/UploadReceipt';  // Import UploadReceipt
import Login from './private/components/Login';
import FormForgotUser from './private/components/FormForgotUser';
import FormRecoverUser from './private/components/FormRecoverUser';
import PrivateRoute from './private/components/PrivateRoute';
import Dashboard from './private/components/Dashboard';


function App() {
  const [isLoggedIn, setLoggedIn] = useState(null);
  // const [clearDashboardInterval, setClearDashboardInterval] = useState(null);
  
  useEffect(() => {
      axios
      .post('https://docuquest-swu.swucite.tech/api_drts/checkAuth.php', {}, { withCredentials: true })
      .then((res) => {
        // console.log(res.data.msgAuth);
        if (res.data.statusAuth === 1) {
          //alert(`Authenticated: ${res.data.msgAuth}`);
          setLoggedIn(true);
        } else {
          //alert(`NOT Authenticated: ${res.data.msgAuth}`);
          setLoggedIn(false);
        }
      })
      .catch((err) => {
        //console.error("ERROR: You are not authenticated! REASON: ", err);
        setLoggedIn(false);
      });
      
      // Cleanup interval when App unmounts
      // return () => {
      //   if (clearDashboardInterval) {
      //     clearDashboardInterval();
      //   }
      // };
  }, []);
  // [clearDashboardInterval]

  if (isLoggedIn === null) {
    return <div>Loading...</div>; // Prevents flickering while checking session
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path='/tracking/:refNumber' element={<SingleTrack/>} />
          <Route path='/request' element={<FormRequest/>} />
          <Route path='/start' element={<MenuMain/>} />
          <Route path='/forgot/find' element={<FormForgotUser/>} />
          <Route path='/forgot/recover' element={<FormRecoverUser/>} />
          <Route path='/login' element={<Login setLoggedIn={setLoggedIn}/>} />
          {/* onClearInterval={setClearDashboardInterval} */}
          <Route path='/*' element={isLoggedIn ? ( 
            // <section className='content_main'>
              <Dashboard replace={true} />
            // </section>
          ) : ( 
          <Navigate to="/start" replace />
          )}/>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
